import React from 'react';
var ReactConfig = {
    LinkComponent: function LinkComponent(param) {
        var draggable = param.draggable, rel = param.rel, title = param.title, href = param.href, target = param.target, className = param.className, label = param.label, style = param.style, children = param.children, onClick = param.onClick;
        return /*#__PURE__*/ React.createElement("a", {
            rel: rel,
            draggable: draggable,
            href: href,
            title: title,
            target: target,
            className: className,
            style: style,
            onClick: onClick
        }, children || label);
    },
    ImageComponent: function ImageComponent(param) {
        var loading = param.loading, src = param.src, srcSet = param.srcSet, alt = param.alt, width = param.width, height = param.height, sizes = param.sizes, artDirection = param.artDirection, className = param.className;
        return /*#__PURE__*/ React.createElement("picture", null, artDirection === null || artDirection === void 0 ? void 0 : artDirection.map(function(media) {
            return /*#__PURE__*/ React.createElement("source", {
                media: media.media,
                sizes: media.sizes,
                srcSet: media.srcSet
            });
        }), /*#__PURE__*/ React.createElement("img", {
            src: src,
            alt: alt,
            srcSet: srcSet,
            loading: loading,
            width: width,
            height: height,
            sizes: sizes,
            className: className
        }));
    }
};
export default ReactConfig;

//# sourceMappingURL=ReactConfig.js.map